export const INTRO_CONSTANTS = {
  title: "Why Migrate from EC2 to Zadara with OneMind ",
  text: "Traditional public cloud models often result in unpredictable costs, limited infrastructure visibility, and vendor constraints. OneMind helps enterprises transition to Zadara’s consumption-based cloud with automated migration, dedicated storage control, and hybrid-ready deployment models — backed by 24/7 support. ",
};
